import { render, staticRenderFns } from "./CreditReportSubmitDocument.vue?vue&type=template&id=536e235f&scoped=true&"
import script from "./CreditReportSubmitDocument.vue?vue&type=script&lang=js&"
export * from "./CreditReportSubmitDocument.vue?vue&type=script&lang=js&"
import style0 from "./CreditReportSubmitDocument.vue?vue&type=style&index=0&id=536e235f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536e235f",
  null
  
)

export default component.exports